export type SnapItemIds = {
  category?: { id: number; child?: { id: number } }
  brand?: { id: number }
  colorGroupId?: number
}

export const snapItemsToString = (
  snapItems: SnapItemIds[]
): string | undefined => {
  return snapItems
    .map(({ brand, category, colorGroupId }) => {
      return [
        category?.id ?? 0,
        category?.child?.id ?? 0,
        brand?.id ?? 0,
        colorGroupId ?? 0,
      ].join('_')
    })
    .join('-')
}
